import React, { useState } from 'react';
// For icons, you might use a library like heroicons
// For this example, I'll use simple text/SVG placeholders or skip them for brevity
// import { ChevronLeftIcon, ChevronRightIcon, PlusCircleIcon, DocumentArrowUpIcon } from '@heroicons/react/24/solid';

const steps = [
  { id: 1, name: 'Basic Info' },
  { id: 2, name: 'Operations' },
  { id: 3, name: 'Contacts' },
  { id: 4, name: 'Documents & Submit' },
];

const VendorForm = () => {
  const [currentStep, setCurrentStep] = useState(1);

  const [vendorName, setVendorName] = useState('');
  const [country, setCountry] = useState('');
  const [uaeCities, setUaeCities] = useState([]);
  const [uaeOffices, setUaeOffices] = useState([]);
  const [expertise, setExpertise] = useState('');
  const [dataCollectionMethod, setDataCollectionMethod] = useState('');
  const [catiStations, setCatiStations] = useState('');
  const [contacts, setContacts] = useState([{ name: '', email: '', mobile: '' }]);
  const [fieldTeam, setFieldTeam] = useState({ fieldworkers: '', supervisors: '', managers: '' });
  const [govPermits, setGovPermits] = useState('');
  const [urgentRequests, setUrgentRequests] = useState('');
  const [tradeLicense, setTradeLicense] = useState(null);
  const [credentials, setCredentials] = useState(null);

  const handleContactChange = (index, field, value) => {
    const updated = [...contacts];
    updated[index][field] = value;
    setContacts(updated);
  };

  const addContact = () => {
    if (contacts.length < 3) {
      setContacts([...contacts, { name: '', email: '', mobile: '' }]);
    }
  };

  const handleFileChange = (setter, e) => {
    if (e.target.files && e.target.files[0]) {
      setter(e.target.files[0]);
    }
  };

  const nextStep = () => {
    if (currentStep < steps.length) {
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    // Basic validation check
    if (!vendorName || !country || !expertise || !dataCollectionMethod || contacts[0].name === '' || contacts[0].email === '' || !urgentRequests || !tradeLicense || !credentials) {
        alert('Please fill all required fields before submitting.');
        // Potentially navigate to the first step with missing required fields
        // For simplicity, just an alert for now.
        return;
    }
    console.log('Form Submitted:', {
      vendorName,
      country,
      uaeCities: country === 'UAE' ? uaeCities : undefined,
      uaeOffices: country === 'UAE' ? uaeOffices : undefined,
      expertise,
      dataCollectionMethod,
      catiStations: dataCollectionMethod === 'CATI' ? catiStations : undefined,
      fieldTeam,
      govPermits,
      contacts,
      urgentRequests,
      tradeLicense: tradeLicense ? tradeLicense.name : null,
      credentials: credentials ? credentials.name : null,
    });
    alert('Form submitted successfully! (Check console)');
    // Reset form or redirect
  };

  const commonInputClass = "mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm p-2";
  const commonLabelClass = "block text-sm font-medium text-gray-700";

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 to-slate-700 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        {/* Stepper */}
        <nav aria-label="Progress" className="mb-8">
          <ol role="list" className="flex items-center">
            {steps.map((step, stepIdx) => (
              <li key={step.name} className={`flex-1 ${stepIdx !== steps.length - 1 ? 'pr-8 sm:pr-20' : ''} relative`}>
                {currentStep > step.id ? (
                  <div className="absolute inset-0 flex items-center" aria-hidden="true">
                    <div className="h-0.5 w-full bg-indigo-600" />
                  </div>
                ) : currentStep === step.id ? (
                   <div className="absolute inset-0 flex items-center" aria-hidden="true">
                    <div className="h-0.5 w-full bg-gray-200" />
                  </div>
                ) : (
                  <div className="absolute inset-0 flex items-center" aria-hidden="true">
                    <div className="h-0.5 w-full bg-gray-200" />
                  </div>
                )}
                <a
                  href="#"
                  onClick={(e) => { e.preventDefault(); if (step.id < currentStep) setCurrentStep(step.id);}}
                  className={`relative flex h-8 w-8 items-center justify-center rounded-full
                    ${currentStep > step.id ? 'bg-indigo-600 hover:bg-indigo-700' : currentStep === step.id ? 'border-2 border-indigo-600 bg-white' : 'border-2 border-gray-300 bg-white hover:border-gray-400'}
                  `}
                >
                  {currentStep > step.id ? (
                    <svg className="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fillRule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clipRule="evenodd" />
                    </svg>
                  ) : (
                    <span className={`${currentStep === step.id ? 'text-indigo-600' : 'text-gray-500'}`}>{step.id}</span>
                  )}
                   <span className="absolute -bottom-6 text-xs font-medium text-gray-300 whitespace-nowrap">{step.name}</span>
                </a>
              </li>
            ))}
          </ol>
        </nav>

        {/* Form Content */}
        <form onSubmit={handleSubmit} className="bg-white shadow-xl rounded-lg p-6 sm:p-8 space-y-6">
          {/* Step 1: Basic Info */}
          {currentStep === 1 && (
            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-6">Vendor Basic Information</h2>
              <div>
                <label htmlFor="vendorName" className={commonLabelClass}>Vendor Name:</label>
                <input type="text" id="vendorName" className={commonInputClass} value={vendorName} onChange={e => setVendorName(e.target.value)} required />
              </div>
              <div>
                <label htmlFor="country" className={commonLabelClass}>Country:</label>
                <select id="country" className={commonInputClass} value={country} onChange={e => setCountry(e.target.value)} required>
                  <option value="">Select Country</option>
                  {["UAE", "KSA", "Kuwait", "Oman", "Qatar", "Bahrain", "Iraq", "Lebanon", "Jordan", "Egypt", "Morocco", "Others"].map(c => (
                    <option key={c} value={c}>{c}</option>
                  ))}
                </select>
              </div>

              {country === 'UAE' && (
                <>
                  <div className="mt-4">
                    <label htmlFor="uaeCities" className={commonLabelClass}>Cities that can be covered (UAE):</label>
                    <select 
                      id="uaeCities" 
                      className={commonInputClass} 
                      multiple 
                      value={uaeCities} 
                      onChange={e => setUaeCities(Array.from(e.target.selectedOptions, option => option.value))}
                    >
                      {["Dubai", "Abu Dhabi City", "Al Ain", "Al Dhafra", "Sharjah", "Northern Emirates"].map(city => (
                        <option key={city} value={city}>{city}</option>
                      ))}
                    </select>
                    <p className="mt-1 text-xs text-gray-500">Hold Ctrl/Cmd to select multiple.</p>
                  </div>

                  <div className="mt-4">
                    <label htmlFor="uaeOffices" className={commonLabelClass}>Offices (UAE):</label>
                    <select 
                      id="uaeOffices" 
                      className={commonInputClass} 
                      multiple
                      value={uaeOffices}
                      onChange={e => setUaeOffices(Array.from(e.target.selectedOptions, option => option.value))}
                    >
                      {["Dubai", "Sharjah", "Abu Dhabi", "Others specify"].map(office => (
                        <option key={office} value={office}>{office}</option>
                      ))}
                    </select>
                    <p className="mt-1 text-xs text-gray-500">Hold Ctrl/Cmd to select multiple.</p>
                  </div>
                </>
              )}
            </section>
          )}

          {/* Step 2: Operations */}
          {currentStep === 2 && (
             <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-6">Operational Details</h2>
              <div>
                <label htmlFor="expertise" className={commonLabelClass}>Expertise:</label>
                <select id="expertise" className={commonInputClass} value={expertise} onChange={e => setExpertise(e.target.value)} required>
                  <option value="">Select Expertise</option>
                  <option value="Quantitative">Quantitative</option>
                  <option value="Qualitative">Qualitative</option>
                  <option value="Both">Both</option>
                </select>
              </div>

              <div>
                <label htmlFor="dataCollectionMethod" className={commonLabelClass}>Data collection methods used:</label>
                <select id="dataCollectionMethod" className={commonInputClass} value={dataCollectionMethod} onChange={e => setDataCollectionMethod(e.target.value)} required>
                  <option value="">Select Method</option>
                  {["Face to face", "CATI", "MS", "Online Panel", "Online (Database)", "CLT", "Focus Group Discussions", "In-Depth Interviews", "Others, specify"].map(method => (
                    <option key={method} value={method}>{method}</option>
                  ))}
                </select>
              </div>

              {dataCollectionMethod === 'CATI' && (
                <div className="mt-4">
                  <label htmlFor="catiStations" className={commonLabelClass}>Number of CATI stations:</label>
                  <input type="number" id="catiStations" className={commonInputClass} min={0} value={catiStations} onChange={e => setCatiStations(e.target.value)} />
                </div>
              )}

              <div className="mt-4">
                <label className={commonLabelClass}>Field team size:</label>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-1">
                  <input
                    type="number"
                    placeholder="Fieldworkers"
                    className={commonInputClass}
                    value={fieldTeam.fieldworkers}
                    onChange={e => setFieldTeam({ ...fieldTeam, fieldworkers: e.target.value })}
                    min={0}
                  />
                  <input
                    type="number"
                    placeholder="Supervisors"
                    className={commonInputClass}
                    value={fieldTeam.supervisors}
                    onChange={e => setFieldTeam({ ...fieldTeam, supervisors: e.target.value })}
                    min={0}
                  />
                  <input
                    type="number"
                    placeholder="Project Managers"
                    className={commonInputClass}
                    value={fieldTeam.managers}
                    onChange={e => setFieldTeam({ ...fieldTeam, managers: e.target.value })}
                    min={0}
                  />
                </div>
              </div>

              <div className="mt-4">
                <label htmlFor="govPermits" className={commonLabelClass}>Field team with official Gov. permits (Number):</label>
                <input
                  type="number"
                  id="govPermits"
                  className={commonInputClass}
                  placeholder="Number of members"
                  value={govPermits}
                  onChange={e => setGovPermits(e.target.value)}
                  min={0}
                />
              </div>
            </section>
          )}

          {/* Step 3: Contacts */}
          {currentStep === 3 && (
            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-6">Contact Details</h2>
              {contacts.map((contact, index) => (
                <div key={index} className="border border-gray-200 p-4 rounded-lg mb-4 shadow-sm bg-gray-50">
                  <h3 className="text-md font-medium text-gray-700 mb-2">Contact #{index + 1} {index === 0 && <span className="text-red-500 text-xs">(Primary)</span>}</h3>
                  <div className="space-y-3">
                    <input
                      type="text"
                      placeholder="Name"
                      value={contact.name}
                      onChange={e => handleContactChange(index, 'name', e.target.value)}
                      className={commonInputClass}
                      required={index === 0}
                    />
                    <input
                      type="email"
                      placeholder="Email ID"
                      value={contact.email}
                      onChange={e => handleContactChange(index, 'email', e.target.value)}
                      className={commonInputClass}
                      required={index === 0}
                    />
                    <input
                      type="tel"
                      placeholder="Mobile Number"
                      value={contact.mobile}
                      onChange={e => handleContactChange(index, 'mobile', e.target.value)}
                      className={commonInputClass}
                      required={index === 0}
                    />
                  </div>
                </div>
              ))}
              {contacts.length < 3 && (
                <button
                  type="button"
                  onClick={addContact}
                  className="mt-2 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  {/* <PlusCircleIcon className="h-5 w-5 mr-2" />  Simple text as placeholder */}
                  + Add Another Contact
                </button>
              )}
            </section>
          )}

          {/* Step 4: Documents & Submit */}
          {currentStep === 4 && (
            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-6">Compliance & Documents</h2>
              <div>
                <label className={commonLabelClass}>Ability to manage urgent requests:</label>
                <div className="flex gap-x-6 mt-2">
                  <label className="inline-flex items-center">
                    <input type="radio" name="urgent" value="yes" className="form-radio h-4 w-4 text-indigo-600 border-gray-300" onChange={e => setUrgentRequests(e.target.value)} checked={urgentRequests === 'yes'} required />
                    <span className="ml-2 text-sm text-gray-700">Yes</span>
                  </label>
                  <label className="inline-flex items-center">
                    <input type="radio" name="urgent" value="no" className="form-radio h-4 w-4 text-indigo-600 border-gray-300" onChange={e => setUrgentRequests(e.target.value)} checked={urgentRequests === 'no'} required />
                    <span className="ml-2 text-sm text-gray-700">No</span>
                  </label>
                </div>
              </div>

              <div className="mt-4">
                <label htmlFor="tradeLicense" className={commonLabelClass}>
                  {/* <DocumentArrowUpIcon className="h-5 w-5 inline mr-1 text-gray-500" /> Placeholder */}
                  Trade license (PDF only):
                </label>
                <input 
                    type="file" 
                    id="tradeLicense" 
                    accept=".pdf" 
                    className={` ${commonInputClass} file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100`} 
                    onChange={(e) => handleFileChange(setTradeLicense, e)} 
                    required 
                />
                {tradeLicense && <p className="text-xs text-gray-500 mt-1">Selected: {tradeLicense.name}</p>}
              </div>

              <div className="mt-4">
                <label htmlFor="credentials" className={commonLabelClass}>
                  {/* <DocumentArrowUpIcon className="h-5 w-5 inline mr-1 text-gray-500" /> Placeholder */}
                  Credentials (PDF only):
                </label>
                <input 
                    type="file" 
                    id="credentials" 
                    accept=".pdf" 
                    className={` ${commonInputClass} file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100`} 
                    onChange={(e) => handleFileChange(setCredentials, e)} 
                    required 
                />
                {credentials && <p className="text-xs text-gray-500 mt-1">Selected: {credentials.name}</p>}
              </div>
            </section>
          )}

          {/* Navigation Buttons */}
          <div className="mt-8 pt-5 border-t border-gray-200">
            <div className="flex justify-between">
              <button
                type="button"
                onClick={prevStep}
                disabled={currentStep === 1}
                className={`py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed`}
              >
                {/* <ChevronLeftIcon className="h-5 w-5 inline mr-1" /> Placeholder */}
                Previous
              </button>
              {currentStep < steps.length ? (
                <button
                  type="button"
                  onClick={nextStep}
                  className="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  Next
                  {/* <ChevronRightIcon className="h-5 w-5 inline ml-1" /> Placeholder */}
                </button>
              ) : (
                <button
                  type="submit"
                  className="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                >
                  Submit Application
                </button>
              )}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default VendorForm;